import { render, staticRenderFns } from "./GameDetails.vue?vue&type=template&id=87c02d3e"
import script from "./GameDetails.vue?vue&type=script&lang=ts"
export * from "./GameDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports